<script>
export default {
    name: 'forkiss-modal',

    props: {
        theme: {
            type: String,
            default: 'primary'
        },
        show: {
            type: Boolean
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        okText: {
            type: String,
            default: '确定'
        }
    },
    computed: {
        wrapperClass() {
            return {
                ['forkiss-modal-' + this.theme]: true
            };
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        ok() {
            this.$emit('ok');
        }
    }
};
</script>

<template lang="pug">
.forkiss-modal(v-show="show", :class="wrapperClass")
    .forkiss-modal-mask
    .forkiss-modal-container
        .forkiss-modal-wrapper
            .forkiss-modal-header
                slot(name="header")
            .forkiss-modal-body
                slot
            .forkiss-modal-footer
                slot(name="footer")
                    button.text-btn.ok-btn(type="text", @click="ok", data-touch="true") {{okText}}
</template>

<style lang="less">
.forkiss-modal {
    position: relative;
}

.forkiss-modal-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 64;
    background-color: rgba(0, 0, 0, .6);
}
.forkiss-modal-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 65;

    .forkiss-modal-wrapper {
        position: absolute;
        width: 6.18rem;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #FFF;
        border-radius: .2rem;
    }
    .forkiss-modal-header {
        position: relative;
        font-size: .32rem;
        font-weight: 600;
        text-align: center;
        padding: .8rem .64rem .4rem;
    }

    .forkiss-modal-body {
        max-height: 10.5rem;
        overflow: auto;
        font-size: .3rem;
        line-height: 1.5;
        padding: 0 .64rem .8rem;
        color: #333;
        text-align: center;
    }

    .forkiss-modal-footer {
        text-align: center;
        font-size: .42rem;

        .text-btn {
            display: block;
            width: 100%;
            height: .84rem;
            line-height: .84rem;
            border: none;
            outline: none;
            font-size: .3rem;
            background: #c3a07b;
            color: #fff;
            border-bottom-left-radius: .1rem;
            border-bottom-right-radius: .1rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/modal.vue